/*
 * @Author: Dong
 * @Date: 2022-04-07 13:40:11
 * @LastEditors: zhang lin
 * @LastEditTime: 2023-02-03 13:54:21
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  checkEnvTitle: '你好，未检测到运维环境， 请选择添加方式。',
  hasNanotube: '若有运维环境，运维平台可纳管',
  hasNotNanotube: '若没有运维环境，运维平台支持创建不同类型的环境',
  nanotube: '纳管环境',
  alone: '单机环境',
  colony: '集群环境',

  addNanobuteTitle: '请填写含有实例的环境的所有主机',
  addNanobuteSubtitle: '运维平台会自动识别环境内的实例',
  deployType: '部署类型',
  deployTypeRequire: '请输入部署类型',
  deployAlone: '单机部署',
  deployColoy: '集群部署',
  deployIP: '节点IP',
  deployIPRequire: '请输入节点IP',
  deployIPCheck: '节点IP不正确',
  deploySSH: 'SSH端口',
  deploySSHRequire: '请输入SSH端口',
  deploySSHCheck: '端口格式不正确',
  deployUser: '账号',
  deployUserRequire: '请输入账号',
  deployPwd: '密码',
  deployPwdRequire: '请输入密码',
  deployFile: '配置文件',
  deployFileRequire: '请上传配置文件',
  deployOk: '纳管',
  deployCancel: '取消',

  deployIng: '正在纳管supOS实例…',
  reNanotube: '重试',
  downloadFail: '下载失败',
  downloadSuccess: '下载成功',
  nanotubeFail: '纳管失败，',
  downloadNanotubeFail: '下载失败文件',
  nanotubeSuccess: '纳管成功',
});
